import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Capacitor } from '@capacitor/core';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Suppress ResizeObserver loop error (common with Radix UI dropdowns)
const resizeObserverErr = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (message && message.toString().includes('ResizeObserver loop')) {
    return true; // Suppress the error
  }
  if (resizeObserverErr) {
    return resizeObserverErr(message, source, lineno, colno, error);
  }
  return false;
};

// Also suppress in error event listener
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Only register service worker for web PWA, NOT for native Capacitor app
// Service workers can cause caching issues in native apps
if (!Capacitor.isNativePlatform()) {
  serviceWorkerRegistration.register({
    onSuccess: () => {
      console.log('[PWA] App is ready for offline use');
    },
    onUpdate: (registration) => {
      console.log('[PWA] New version available');
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    },
  });
} else {
  console.log('[Native] Running in Capacitor native app - service worker disabled');
  // Unregister any existing service worker in native app
  serviceWorkerRegistration.unregister();
}
